import React from "react";
import BreadCrumb from "common/breadcrumb";
import DefaultOutline from "./default-outline";
import PillsDismissible from "./pills-dismissible";
import FillBadges from "./fill-badges";
import LabelBadge from "./label-badge";

const UiLabel = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Label' pageTitle='UI Elements' />
                <div>
                    <DefaultOutline />
                    <PillsDismissible />
                    <FillBadges />
                    <LabelBadge />
                </div>
            </div>
        </React.Fragment>
    );
}

export default UiLabel;